import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    GetRouteSheetDetailsResponse,
    GetRouteSheetParams,
    GetRouteSheetResponse,
} from '@/new-services/types/route-sheet'

type ApiGetRouteSheetResponse = Promise<AxiosResponse<GetRouteSheetResponse>>
type ApiGetRouteSheetDetailsResponse = Promise<AxiosResponse<GetRouteSheetDetailsResponse>>
type ApiDownloadRouteSheetReportResponse = Promise<AxiosResponse<any>>
type ApiResendOneCResponse = Promise<AxiosResponse<void>>

export function getRouteSheet(params: GetRouteSheetParams): ApiGetRouteSheetResponse {
    return http.get('/dispatcher/api/route-sheet', { params })
}

export function getRouteSheetDetails(route_sheet_id: number): ApiGetRouteSheetDetailsResponse {
    return http.get(`/dispatcher/api/route-sheet/${route_sheet_id}`)
}

export function resendOneC(id: number): ApiResendOneCResponse {
    return http.post(`/dispatcher/api/route-sheet/${id}/resend`, { id })
}

export function downloadReport(route_sheet_id: number): ApiDownloadRouteSheetReportResponse {
    return http.get(`/dispatcher/api/route-sheet/${route_sheet_id}/report`, {
        responseType: 'blob',
    })
}

export default {
    getRouteSheet,
    getRouteSheetDetails,
    downloadReport,
    resendOneC,
}
